import React, { useState } from "react";
import { Link } from "react-router-dom";

import { mapGender, copyToClipboard, renderCopyIcon } from "../utils/utils.js";
import { FaLinkedin, FaInstagram } from "react-icons/fa";

function Profile({ user }) {
  // Destructure user data from props
  console.log("user", user);
  const { name, email_address, phone_number, phone_number_self_described, gender, year_of_birth, biography, clients, called, occupation, occupation_self_described, marital_status, marital_status_self_described, notes, market, household_income, instagram, linkedin, blacklist, participation } = user;
  const [copiedId, setCopiedId] = useState(false);
  const [copiedPhoneNumber, setCopiedPhoneNumber] = useState(false);
  const income = household_income ? "$" + parseFloat(household_income).toLocaleString("en-US", { maximumFractionDigits: 0 }) : "";

  return (
    <div className="container mx-auto w-full pl-5">
      <div className="prose header pb-5">
        <h2>
          {name},{user.year_of_birth && user.year_of_birth >= 1900 ? <span className="text-md"> {new Date().getFullYear() - user.year_of_birth}</span> : ""} {mapGender(user.gender)}
          {user.blacklist && <span className="text-danger"> (Blacklisted)</span>}
        </h2>
      </div>

      <div className="header grid grid-cols-2 gap-4">
        <div className="prose">
          <blockquote>{biography}</blockquote>
        </div>
        <div className="prose">
          <div id="socials">
            <strong>Social Media:</strong>
            {instagram ? (
              <a href={`https://www.instagram.com/${instagram}`}>
                <FaInstagram />
              </a>
            ) : (
              <></>
            )}
            {linkedin ? (
              <a href={`https://www.instagram.com/${linkedin}`}>
                <FaLinkedin />
              </a>
            ) : (
              <></>
            )}
            <div></div>
          </div>
          <p>
            <strong>Ethnicity:</strong> {user.ethnicity.join(" & ")}
          </p>
          <p>
            <strong>Occupation:</strong> {occupation ? occupation : occupation_self_described}
          </p>
          <p>
            <strong>Marital Status:</strong> {marital_status ? marital_status : marital_status_self_described}
          </p>
          <p>
            <strong>Market:</strong> {market}
          </p>
          <p>
            <strong>Household Income:</strong> {income}
          </p>
          <p>
            <strong>Email:</strong> {email_address}
            {renderCopyIcon(email_address, copiedId, setCopiedId)}
          </p>
          <p>
            <strong>Phone Number:</strong> {phone_number_self_described}
            {renderCopyIcon(phone_number, copiedPhoneNumber, setCopiedPhoneNumber)}
          </p>
          <strong>Participated in:</strong>
          <ul>
            {participation && Array.isArray(participation) ? (
              participation.map((project, index) => <li key={index}>{project}</li>)
            ) : (
              <li>No participation data available.</li> // Fallback content
            )}
          </ul>
          <strong>Call List for:</strong>
          <ul>
            {Array.isArray(called) ? (
              called.map((project, index) => <li key={index}>{project}</li>)
            ) : (
              <li>No called data available.</li> // Fallback content
            )}
          </ul>

          <strong>Notes:</strong>
          <blockquote>{notes}</blockquote>
        </div>
      </div>
    </div>
  );
}

export default Profile;
